import React, { useState, useMemo, useEffect } from "react";
import Calendar from "react-calendar";
import moment from "moment";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "react-calendar/dist/Calendar.css";

import Icon from "../components/Icon";
import { StyledText } from "../components";
import Modal from "../components/Modal";
import ListSelect from "../components/ListSelect";
import {
  getAllSchemes,
  addScheme,
  updateScheme,
  clearAddScheme,
  getSchemesById,
} from "../actions/scheme-action-types";
import {
  getAllStates,
  getAllDealers,
  getAllDistricts,
  getAllTehsils,
} from "../actions/dealer-action-types";
import { getAllModel } from "../actions/user-action-types";
import {
  arrUniqBy,
  uploadFileToBlob,
  validateUrl,
} from "../utilities/utilsFunction";
import { Circle } from "../components/Overlay";
import DistributionSelect from "../components/DistributionSelect";
import SelectCross from "../components/SelectCross";
import { tenentId } from "../constant";

import ConfigData from "../config/config-json.json";

const { languageOptions, applicationNames, documentTypes, securityType } =
  ConfigData;
const CalendarComponent = ({ date, onChange, minDate }) => {
  return (
    <div>
      <Calendar
        value={date || new Date()}
        onChange={onChange}
        minDate={minDate || new Date()}
      />
    </div>
  );
};

const loaderCss = {
  position: "absolute",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignContent: "center",
  backgroundColor: "rgb(0,0,0,0.3)",
  alignItems: "center",
  zIndex: 99999,
  top: 0,
  left: 0,
};

const mainContainer = {
  padding: "40px 40px 90px",
};

const headingText = {
  fontFamily: "Roboto-Bold",
  fontSize: "24px",
  color: "#003E85",
};

const infoText = {
  color: "#060808",
  fontFamily: "Roboto-Bold",
  fontSize: "18px",
};

const containerWrapper = {
  backgroundColor: "#F5F5F5",
  height: 46,
  borderBottom: "2px solid #003E85",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
  paddingRight: "10px",
  cursor: "pointer",
};

const containerDiv = {
  display: "flex",
  flexDirection: "column",
  marginLeft: "10px",
  flex: 1,
};

const containerTitle = {
  fontFamily: "Roboto-Regular",
  fontSize: "12px",
  color: "#515353",
};

const descriptionInput = {
  fontFamily: "Roboto-Regular",
  color: "#060808",
  fontSize: "16px",
  backgroundColor: "#F5F5F5",
  border: "none",
};

const distributionTypeWrapper = {
  display: "flex",
  flexDirection: "row",
  marginTop: "10px",
  marginBottom: "15px",
};

const backContainer = {
  backgroundColor: "#003E85",
  display: "flex",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  marginBottom: "20px",
};

const UploadSchemes = ({
  allStates,
  allDealers,
  getAllSchemes,
  addScheme,
  updateScheme,
  getAllDealers,
  getAllStates,
  addSchemeSuccess,
  clearAddScheme,
  visible,
  isUpdate,
  allModels,
  getAllModel,
  getAllDistricts,
  getAllTehsils,
  allTehsils,
  allDistricts,
  getSchemesById,
  schemeById,
  ...props
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgUrl, setImgUrl] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showStartDate, setShowStartDate] = useState(false);
  const [showEndDate, setShowEndDate] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedState, setSelectedState] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedTehsil, setSelectedTehsil] = useState([]);
  const [selectedDealers, setSelectedDealers] = useState([]);

  const [schemeDescription, setSchemeDescription] = useState("");
  const [showStateList, setShowStateList] = useState(false);
  const [showDistrictList, setShowDistrictList] = useState(false);
  const [showTehsilList, setShowTehsilList] = useState(false);
  const [showDealerList, setShowDealerList] = useState(false);
  const [distributionType, setDistributionType] = useState("area");
  const [updateSchemeId, setUpdateSchemeId] = useState(null);
  const [showERPList, setShowERPList] = useState(false);
  const [selectedDealerERP, setSelectedDealerERP] = useState([]);

  const [showDocumentType, setShowDocumentType] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [selectedDocumetType, setSelectedDocumentType] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState([]);
  const [selectedModel, setSelectedModel] = useState([]);
  const [documentName, setDocumentName] = useState("");
  const [isDownloadable, setIsDownloadable] = useState("");
  const [isShareable, setIsShareable] = useState("");
  const [showApplicationName, setShowApplicationName] = useState(false);
  const [selectedApplicationName, setSelectedApplicationName] = useState([]);
  const [selectedSecurityType, setSelectedSecurityType] = useState([]);
  const [showSecurityType, setShowSecurityType] = useState(false);

  const [allStateSelect, setAllStateSelect] = useState(false);
  const [allDistrictSelect, setAllDistrictSelect] = useState(false);
  const [allTehsilSelect, setAllTehsilSelect] = useState(false);
  const [allDealerSelect, setAllDealerSelect] = useState(false);
  const [allDealerERPSelect, setAllDealerERPSelect] = useState(false);
  const [allModelSelect, setAllModelSelect] = useState(false);

  const [showAllStateList, setShowAllStateList] = useState(false);
  const [showAllDistrictList, setShowAllDistrictList] = useState(false);
  const [showAllTehsilList, setShowAllTehsilList] = useState(false);
  const [showAllDealerList, setShowAllDealerList] = useState(false);
  const [showAllDealerERPList, setShowAllDealerERPList] = useState(false);

  const [isSelectAll, setIsSelectAll] = useState(false);

  const location = useLocation();
  const params = location.state;

  useEffect(() => {
    getAllStates();
    getAllDistricts();
    getAllTehsils();
    getAllDealers();
    getAllModel();
    if (params) {
      setSelectedApplicationName(params?.selectedApplicationName ?? []);
      setSelectedDocumentType(
        params?.selectedDocumetType?.[0]?.label !== "All"
          ? params?.selectedDocumetType
          : []
      );
      setIsDownloadable(true);
      setIsShareable(false);
    }
    if (isUpdate) {
      const schemeId = props.match.params.schemeId;
      setUpdateSchemeId(schemeId);
      getSchemesById(schemeId);
    }
  }, []);

  useEffect(() => {
    if (addSchemeSuccess) {
      setShowSuccessModal(true);
    }
  }, [addSchemeSuccess]);

  let history = useHistory();

  const modelsList = useMemo(() => {
    return allModels
      ?.sort(function (a, b) {
        return a.mODEL_NAME.localeCompare(b.mODEL_NAME, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
      .map(({ mODEL_NAME, model_Id }) => ({
        value: model_Id,
        label: mODEL_NAME,
      }));
  }, [allModels]);

  const states = useMemo(() => {
    return allStates?.reduce?.((arr, { State_Id, State_Name }) => {
      if (State_Id !== 0) {
        arr.push({
          value: State_Id,
          label: State_Name,
        });
      }
      return arr;
    }, []);
  }, [allStates]);

  const districtsList = useMemo(() => {
    return (
      allDistricts?.reduce?.((arr, val) => {
        if (val?.District_Id) {
          arr.push({
            value: val.District_Id,
            label: val.District_Name,
            ...val,
          });
        }
        return arr;
      }, []) ?? []
    );
  }, [allDistricts]);

  const districts = useMemo(() => {
    if (selectedState?.length && allDistricts?.length) {
      const distList = allDistricts?.reduce?.((arr, val) => {
        const state = selectedState?.findIndex((s) => s.value === val.state_id);
        if (val?.District_Id && state > -1) {
          arr.push({
            value: val.District_Id,
            label: val.District_Name,
            ...val,
          });
        }
        return arr;
      }, []);
      return distList;
    }
    return [];
  }, [selectedState, allDistricts]);

  const tehsilsList = useMemo(() => {
    return (
      allTehsils?.reduce?.((arr, val) => {
        if (val?.tehsil_id) {
          arr.push({
            value: val.tehsil_id,
            label: val.Tehsil_Name,
            ...val,
          });
        }
        return arr;
      }, []) ?? []
    );
  }, [allTehsils]);

  const tehsils = useMemo(() => {
    if (selectedDistrict?.length && allTehsils?.length) {
      const tehsilList = allTehsils?.reduce?.((arr, val) => {
        const dist = selectedDistrict?.findIndex(
          (s) => s.value === val.city_id
        );
        if (val?.tehsil_id && dist > -1) {
          arr.push({
            value: val.tehsil_id,
            label: val.Tehsil_Name,
            ...val,
          });
        }
        return arr;
      }, []);
      return tehsilList;
    }
    return [];
  }, [selectedDistrict, allTehsils]);

  const dealersERPList = useMemo(() => {
    const erpCodes = allDealers?.reduce?.((arr, dealer) => {
      const i = arr.findIndex((val) => val.value === dealer?.erpcbucode);
      if (i < 0 && dealer?.erpcbucode) {
        arr.push({
          value: dealer?.erpcbucode,
          label: dealer?.erpcbucode,
        });
      }
      return arr;
    }, []);
    return erpCodes;
  }, [allDealers]);

  const dealersList = useMemo(() => {
    try {
      const dealers = allDealers?.reduce?.((arr, dealer) => {
        const i = selectedDealerERP?.findIndex(
          (val) => val.value === dealer?.erpcbucode
        );
        if (i >= 0) {
          arr.push({
            ...dealer,
            value: dealer?.dealerCode,
            label: dealer?.dealerName,
          });
        }
        return arr;
      }, []);
      return dealers;
    } catch {
      return [];
    }
  }, [selectedDealerERP]);

  const allDealersList = useMemo(() => {
    try {
      const dealers = allDealers?.reduce?.((arr, dealer) => {
        if (dealer?.erpcbucode) {
          arr.push({
            ...dealer,
            value: dealer?.dealerCode,
            label: dealer?.dealerName,
          });
        }
        return arr;
      }, []);
      return dealers;
    } catch {
      return [];
    }
  }, [allDealers]);

  useEffect(() => {
    if (updateSchemeId && isUpdate) {
      const scheme = schemeById;
      const fileName = scheme?.docUrl?.split?.("/");
      const appId = applicationNames.find((val) => val.value === scheme?.appId);
      const lang = languageOptions?.find(
        (val) => val.value === scheme?.language
      );
      const doc = documentTypes?.find((val) => val.value === scheme?.docType);
      const model = modelsList?.find((val) => val.label === scheme?.modelNo);
      setSelectedFile({
        name: fileName?.[fileName?.length - 1],
        type: scheme?.contentType,
        size: scheme?.size,
      });
      !!scheme?.security &&
        setSelectedSecurityType([
          { label: scheme?.security, value: scheme?.security },
        ]);
      setSelectedApplicationName([appId]);
      setSelectedDocumentType([doc]);
      setSelectedLanguage([lang]);
      setSelectedModel([model || {}]);
      setDocumentName(scheme?.docName ?? "");
      setSchemeDescription(scheme?.description);
      setDistributionType(scheme?.distributionType);
      setImgUrl(scheme?.docUrl ?? "");
      setStartDate(scheme?.startDate ? new Date(scheme?.startDate) : "");
      setEndDate(scheme?.endDate ? new Date(scheme?.endDate) : "");
      setIsDownloadable(scheme?.downloadable ?? "");
      setIsShareable(scheme?.shareable ?? "");
      const schemeStates = [];
      const schemeDistricts = [];
      const schemeTehsils = [];
      const schemeDealers = [];
      const dealerERP = [];
      if (scheme.distributionAll) {
        setIsSelectAll(true);
      } else {
        scheme?.distributions?.map((val) => {
          const state = states.find((s) => s.value === val.stateId);
          const district = districtsList.find(
            (d) => d.value === val.districtId
          );
          const tehsil = tehsilsList.find((t) => t.value === val.tehsilId);
          const dealer = allDealers?.find?.(
            (d) => d.district_id === val.districtId
          );
          schemeStates.push(state);
          schemeDistricts.push(district);
          schemeTehsils.push(tehsil);
          schemeDealers.push({
            ...dealer,
            value: dealer?.dealerCode,
            label: dealer?.dealerName,
          });
          dealerERP.push({
            value: dealer?.erpcbucode,
            label: dealer?.erpcbucode,
          });
        });
      }
      if (
        !scheme.distributionAll &&
        scheme?.distributionType === "area" &&
        schemeStates.length
      ) {
        const state = arrUniqBy(schemeStates, "value");
        const district = arrUniqBy(schemeDistricts, "value");
        const tehsil = arrUniqBy(schemeTehsils, "value");
        setSelectedDistrict([...district]);
        setSelectedState([...state]);
        setSelectedTehsil([...tehsil]);
      } else if (dealerERP.length) {
        setSelectedDealers(arrUniqBy(schemeDealers, "value"));
        setSelectedDealerERP(arrUniqBy(dealerERP, "value"));
      }
    }
  }, [
    updateSchemeId,
    schemeById,
    states,
    districtsList,
    allDealers,
    isUpdate,
    tehsilsList,
  ]);

  const clearDistributions = () => {
    setSelectedDealers([]);
    setSelectedState([]);
    setSelectedDistrict([]);
    setSelectedTehsil([]);
    setSelectedDealerERP([]);
    setIsSelectAll(false);
    setAllDealerSelect(false);
    setAllStateSelect(false);
    setAllDistrictSelect(false);
    setAllTehsilSelect(false);
    setAllDealerERPSelect(false);
    setShowAllDealerList(false);
    setShowAllDistrictList(false);
    setShowAllStateList(false);
    setShowAllTehsilList(false);
    setShowAllDealerERPList(false);
  };

  const onFileChange = async (event) => {
    // Update the file
    setSelectedFile(event.target.files[0]);
    try {
      const uploadedBlob = await uploadFileToBlob(event.target.files[0]);
      if (uploadedBlob) {
        setImgUrl(uploadedBlob);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const onChangeState = (val) => {
    const i = selectedState.findIndex((e) => e.value === val.value);
    if (i > -1) {
      selectedState.splice(i, 1);
      setSelectedState([...selectedState]);
      setAllStateSelect(false);
      const filteredDist = selectedDistrict.reduce((arr, dist) => {
        if (dist.state_id !== val.value) {
          arr.push(dist);
        }
        return arr;
      }, []);
      setSelectedTehsil([]);
      setSelectedDistrict([...filteredDist]);
    } else {
      const uniqueVal = arrUniqBy([...selectedState, val], "value");
      setSelectedState([...uniqueVal]);
    }
  };

  const onChangeDistrict = (val) => {
    const i = selectedDistrict.findIndex((e) => e.value === val.value);
    if (i > -1) {
      selectedDistrict.splice(i, 1);
      setSelectedDistrict([...selectedDistrict]);
      setAllDistrictSelect(false);
      const filteredTehsil = selectedTehsil?.reduce((arr, tehsil) => {
        if (tehsil.city_id !== val.value) {
          arr.push(tehsil);
        }
        return arr;
      }, []);
      setSelectedTehsil([...filteredTehsil]);
    } else {
      const uniqueVal = arrUniqBy([...selectedDistrict, val], "value");
      setSelectedDistrict([...uniqueVal]);
    }
  };

  const onChangeTehsil = (val) => {
    const i = selectedTehsil.findIndex((e) => e.value === val.value);
    if (i > -1) {
      selectedTehsil.splice(i, 1);
      setSelectedTehsil([...selectedTehsil]);
      setAllTehsilSelect(false);
    } else {
      const uniqueVal = arrUniqBy([...selectedTehsil, val], "value");
      setSelectedTehsil([...uniqueVal]);
    }
  };

  const onChangeDealer = (val) => {
    const i = selectedDealers.findIndex((e) => e.value === val.value);
    if (i > -1) {
      selectedDealers.splice(i, 1);
      setSelectedDealers([...selectedDealers]);
      setAllDealerSelect(false);
    } else {
      const uniqueVal = arrUniqBy([...selectedDealers, val], "value");
      setSelectedDealers([...uniqueVal]);
    }
  };

  const onChangeDealerERP = (val) => {
    const i = selectedDealerERP.findIndex((e) => e.value === val.value);
    if (i > -1) {
      selectedDealerERP.splice(i, 1);
      setSelectedDealerERP([...selectedDealerERP]);
      setAllDealerERPSelect(false);
      const filteredDealer = selectedDealers.reduce((arr, dealer) => {
        if (dealer.erpcbucode !== val.value) {
          arr.push(dealer);
        }
        return arr;
      }, []);
      if (filteredDealer?.length === 0) {
        setAllDealerSelect(false);
      }
      setSelectedDealers([...filteredDealer]);
    } else {
      const uniqueVal = arrUniqBy([...selectedDealerERP, val], "value");
      setSelectedDealerERP([...uniqueVal]);
    }
  };

  const onChangeModel = (val) => {
    if (isUpdate) {
      setSelectedModel([val]);
      setShowModel(false);
    } else {
      const i = selectedModel.findIndex((e) => e.value === val.value);
      if (i > -1) {
        selectedModel.splice(i, 1);
        setSelectedModel([...selectedModel]);
        setAllModelSelect(false);
      } else {
        const uniqueVal = arrUniqBy([...selectedModel, val], "value");
        setSelectedModel([...uniqueVal]);
      }
    }
  };

  const selectAllState = () => {
    if (allStateSelect) {
      setAllStateSelect(false);
      setAllDistrictSelect(false);
      setSelectedState([]);
      setSelectedDistrict([]);
      setShowAllStateList(false);
    } else {
      const allSelectedStates = states.reduce((arr, val) => {
        arr.push(val);
        return arr;
      }, []);
      setSelectedState([...allSelectedStates]);
      setAllStateSelect(true);
    }
  };

  const selectAllDistrict = () => {
    if (allDistrictSelect) {
      setAllDistrictSelect(false);
      setSelectedDistrict([]);
      setShowAllDistrictList(false);
    } else {
      const allSelectedDistricts = districts.reduce((arr, val) => {
        arr.push(val);
        return arr;
      }, []);
      setSelectedDistrict([...allSelectedDistricts]);
      setAllDistrictSelect(true);
    }
  };

  const selectAllTehsil = () => {
    if (allTehsilSelect) {
      setAllTehsilSelect(false);
      setSelectedTehsil([]);
      setShowAllTehsilList(false);
    } else {
      const allSelectedTehsil = tehsils.reduce((arr, val) => {
        arr.push(val);
        return arr;
      }, []);
      setSelectedTehsil([...allSelectedTehsil]);
      setAllTehsilSelect(true);
    }
  };

  const selectAllDealer = () => {
    if (allDealerSelect) {
      setAllDealerSelect(false);
      setSelectedDealers([]);
      setShowAllDealerList(false);
    } else {
      setSelectedDealers([...dealersList]);
      setAllDealerSelect(true);
    }
  };

  const selectAllDealerERP = () => {
    if (allDealerERPSelect) {
      setAllDealerERPSelect(false);
      setSelectedDealerERP([]);
      setShowAllDealerERPList(false);
      setSelectedDealers([]);
      setAllDealerSelect(false);
    } else {
      const allSelectedDealersERP = dealersERPList.reduce((arr, val) => {
        arr.push(val);
        return arr;
      }, []);
      setSelectedDealerERP([...allSelectedDealersERP]);
      setAllDealerERPSelect(true);
    }
  };

  const selectAllModel = () => {
    if (allModelSelect) {
      setSelectedModel([]);
      setAllModelSelect(false);
    } else {
      setAllModelSelect(true);
      setSelectedModel([...modelsList]);
    }
  };

  const isSubmitEnable = () => {
    if (
      validateUrl(encodeURI(imgUrl)) &&
      (selectedTehsil?.length || selectedDealers?.length) &&
      selectedApplicationName?.length &&
      selectedDocumetType?.length &&
      selectedLanguage?.length &&
      documentName?.length
    ) {
      return true;
    }
    return false;
  };

  const handleSubmit = () => {
    if (isSubmitEnable()) {
      let selectedDistributers = [];
      if (distributionType === "area") {
        selectedDistributers = selectedTehsil?.reduce?.((arr, tehsil) => {
          const dealer = allDealers?.find?.(
            (d) => d.tehsil_id === tehsil.value
          );
          const dist = allDistricts?.find?.(
            (d) => d.District_Id === tehsil?.city_id
          );
          const distributer = {
            dealerCode: dealer?.dealerCode ?? "",
            stateId: dealer?.state_id || dist?.state_id || "",
            districtId: dealer?.district_id || tehsil?.city_id || "",
            tehsilId: dealer?.tehsil_id || tehsil?.value || "",
            updateBy: "Admin",
            modifiedBy: "Admin",
          };
          arr.push(distributer);
          return arr;
        }, []);
      } else {
        selectedDistributers = selectedDealers.reduce((arr, dealer) => {
          const distributer = {
            dealerCode: dealer?.dealerCode ?? "",
            stateId: dealer?.state_id ?? "",
            districtId: dealer?.district_id ?? "",
            tehsilId: dealer?.tehsil_id ?? "",
            updateBy: "Admin",
            modifiedBy: "Admin",
          };
          arr.push(distributer);
          return arr;
        }, []);
      }
      const scheme = {
        startDate: moment(startDate || new Date()).format("DD-MM-YYYY"),
        endDate: endDate ? moment(endDate).format("DD-MM-YYYY") : "",
        description: schemeDescription,
        distributionType: distributionType,
        distributions: isSelectAll ? [] : selectedDistributers,
        distributionAll: isSelectAll,
        status: false,
        updateBy: "Admin",
        modifiedBy: "Admin",
        appId: selectedApplicationName?.[0]?.value,
        tenentId: tenentId,
        docType: selectedDocumetType?.[0]?.value,
        docName: documentName,
        downloadable: isDownloadable,
        shareable: isShareable,
        language: selectedLanguage?.[0]?.value,
        contentType: selectedFile?.type ?? "youtube",
        security: selectedSecurityType?.[0]?.label ?? "",
        size: selectedFile?.size ?? 0,
        docUrl: encodeURI(imgUrl),
        distributionControl: false,
        models: [selectedModel?.[0]?.label ?? ""],
      };
      if (isUpdate) {
        const reqObj = {
          docId: Number(updateSchemeId),
          ...scheme,
        };
        updateScheme(reqObj);
      } else {
        let modelList = [],
          schemesList = [];
        if (selectedModel?.length) {
          modelList = selectedModel.map((val) => {
            return val?.label;
          });
          schemesList = [{ ...scheme, models: modelList }];
        } else {
          schemesList = [{ ...scheme, models: [] }];
        }
        const reqObj = {
          documents: schemesList,
        };
        addScheme(reqObj);
      }
    } else {
      return null;
    }
  };

  const getSelectedStateList = () => {
    const states = [...selectedState];
    if (showAllStateList) return states;
    return states.splice(0, 5);
  };

  const getSelectedDistrictList = () => {
    const district = [...selectedDistrict];
    if (showAllDistrictList) return district;
    return district.splice(0, 5);
  };

  const getSelectedTehsilList = () => {
    const tehsil = [...selectedTehsil];
    if (showAllTehsilList) return tehsil;
    return tehsil.splice(0, 5);
  };

  const getSelectedDealerList = () => {
    const dealers = [...selectedDealers];
    if (showAllDealerList) return dealers;
    return dealers.splice(0, 5);
  };

  const getSelectedDealerERPList = () => {
    const dealers = [...selectedDealerERP];
    if (showAllDealerERPList) return dealers;
    return dealers.splice(0, 5);
  };

  const handleSelectAll = () => {
    switch (true) {
      case distributionType === "area" && !isSelectAll:
        setSelectedTehsil(tehsilsList);
        setSelectedState([]);
        setSelectedDistrict([]);
        setShowStateList(false);
        break;
      case distributionType === "area" && isSelectAll:
        setSelectedTehsil([]);
        break;
      case distributionType === "dealer" && !isSelectAll:
        setSelectedDealers(allDealersList);
        setSelectedDealerERP([]);
        setShowERPList(false);
        break;
      case distributionType === "dealer" && isSelectAll:
        setSelectedDealers([]);
        break;
      default:
        break;
    }
    setIsSelectAll(!isSelectAll);
  };

  const documentTypesFilter = useMemo(() => {
    return documentTypes.filter((val) => val.label !== "All");
  }, []);

  return (
    <>
      {visible && (
        <div style={loaderCss}>
          <Circle size="Large" />
        </div>
      )}
      <div style={mainContainer}>
        <div style={backContainer} onClick={() => history.goBack()}>
          <Icon icon="backIcon" />
        </div>
        <text style={headingText}>
          {isUpdate ? "EDIT DOCUMENTS" : "UPLOAD DOCUMENTS"}
        </text>
        <div style={{ marginTop: "20px" }}>
          <text style={infoText}>DOCUMENT</text>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "13px" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 1 }}>
                <ListSelect
                  heading="Application Name"
                  defaultOption={
                    selectedApplicationName?.length
                      ? selectedApplicationName[0]?.label
                      : "Application Name"
                  }
                  options={applicationNames}
                  selectedOptions={selectedApplicationName}
                  showOptions={showApplicationName}
                  onClickShow={() => {
                    setShowApplicationName(!showApplicationName);
                  }}
                  onClickOption={(val) => {
                    setSelectedApplicationName([val]);
                    setShowApplicationName(false);
                  }}
                  singleSelect
                />
              </div>
              <div style={{ flex: 1, marginLeft: 30 }}>
                <ListSelect
                  heading="Document Type"
                  defaultOption={
                    selectedDocumetType?.length
                      ? selectedDocumetType[0]?.label
                      : "Document Type"
                  }
                  options={documentTypesFilter}
                  selectedOptions={selectedDocumetType}
                  showOptions={showDocumentType}
                  onClickShow={() => setShowDocumentType(!showDocumentType)}
                  onClickOption={(val) => {
                    setSelectedDocumentType([val]);
                    setImgUrl("");
                    setSelectedFile({});
                    if (val?.value === "youtube") {
                      setIsDownloadable(false);
                      setIsShareable(true);
                    } else {
                      setIsDownloadable(true);
                      setIsShareable(false);
                    }
                    setShowDocumentType(false);
                  }}
                  singleSelect
                />
              </div>
            </div>
            <div style={{ flex: 1, marginLeft: 30 }}>
              {selectedDocumetType?.[0]?.value === "youtube" ? (
                <div style={containerWrapper}>
                  <div style={containerDiv}>
                    <text style={containerTitle}>Youtube Link</text>
                    <input
                      type="text"
                      value={imgUrl}
                      onChange={(event) => setImgUrl(event.target.value)}
                      style={descriptionInput}
                      placeholder="Youtube Link"
                    />
                  </div>
                </div>
              ) : (
                <div
                  style={containerWrapper}
                  onClick={() =>
                    document.getElementById("selectImage")?.click?.()
                  }
                >
                  <div style={containerDiv}>
                    <text style={containerTitle}>Browse</text>
                    <text style={{ color: "#060808" }}>
                      {selectedFile?.name || `Document Upload`}
                    </text>
                  </div>
                  <text style={{ color: "#003E85", fontFamily: "Roboto-Bold" }}>
                    {selectedDocumetType[0] ? `</>` : ""}
                  </text>
                  {selectedDocumetType?.[0]?.value && (
                    <input
                      id="selectImage"
                      hidden
                      type="file"
                      onChange={onFileChange}
                      accept={
                        selectedDocumetType?.[0]?.value === "OFFER"
                          ? "text/html"
                          : "*/*"
                      }
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "30px" }}
          >
            <div style={{ flex: 1 }}>
              <ListSelect
                heading="Language"
                defaultOption={
                  selectedLanguage?.length
                    ? selectedLanguage[0]?.label
                    : "Language"
                }
                options={languageOptions}
                selectedOptions={selectedLanguage}
                showOptions={showLanguage}
                onClickShow={() => setShowLanguage(!showLanguage)}
                onClickOption={(val) => {
                  setSelectedLanguage([val]);
                  setShowLanguage(false);
                }}
                singleSelect
              />
            </div>
            <div style={{ flex: 1, marginLeft: 30 }}>
              <ListSelect
                heading="Model"
                defaultOption={
                  selectedModel?.length ? selectedModel[0]?.label : "Model"
                }
                options={modelsList || []}
                selectedOptions={selectedModel}
                showOptions={showModel}
                onClickShow={() => setShowModel(!showModel)}
                onClickOption={(val) => {
                  onChangeModel(val);
                }}
                onClickSelectAll={selectAllModel}
                isSelectAll={allModelSelect}
                singleSelect={isUpdate}
              />
            </div>
            <div style={{ flex: 1, marginLeft: 30 }}>
              <ListSelect
                heading="Security Type"
                defaultOption={
                  selectedSecurityType?.length
                    ? selectedSecurityType[0]?.label
                    : "Security Type"
                }
                options={securityType}
                selectedOptions={selectedSecurityType}
                showOptions={showSecurityType}
                onClickShow={() => setShowSecurityType(!showSecurityType)}
                onClickOption={(val) => {
                  setSelectedSecurityType([val]);
                  setShowSecurityType(false);
                }}
                singleSelect
              />
            </div>
            <div style={{ flex: 1, marginLeft: 30 }}></div>
          </div>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "30px" }}
          >
            <div style={{ flex: 1, marginRight: 30 }}>
              <div style={containerWrapper}>
                <div style={containerDiv}>
                  <text style={containerTitle}>Document Name</text>
                  <input
                    type="text"
                    value={documentName}
                    onChange={(event) => setDocumentName(event.target.value)}
                    style={descriptionInput}
                    placeholder="Document Name"
                  />
                </div>
              </div>
            </div>
            <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 1 }}>
                <div
                  style={containerWrapper}
                  onClick={() => setShowStartDate(!showStartDate)}
                >
                  <div style={containerDiv}>
                    <text style={containerTitle}>Start Date</text>
                    <text style={{ color: "#060808" }}>
                      {startDate
                        ? moment(startDate).format("DD/MM/YYYY")
                        : `Start Date`}
                    </text>
                  </div>
                  <Icon icon="calendar" />
                </div>
                {showStartDate && (
                  <CalendarComponent
                    date={startDate}
                    onChange={(date) => {
                      setShowStartDate(!showStartDate);
                      setStartDate(date);
                      setEndDate("");
                    }}
                  />
                )}
              </div>
              <div style={{ flex: 1, marginLeft: 30 }}>
                <div
                  style={containerWrapper}
                  onClick={() => setShowEndDate(!showEndDate)}
                >
                  <div style={containerDiv}>
                    <text style={containerTitle}>End Date</text>
                    <text style={{ color: "#060808" }}>
                      {endDate
                        ? moment(endDate).format("DD/MM/YYYY")
                        : `End Date`}
                    </text>
                  </div>
                  <Icon icon="calendar" />
                </div>
                {showEndDate && (
                  <CalendarComponent
                    date={endDate}
                    onChange={(date) => {
                      setShowEndDate(!showEndDate);
                      setEndDate(date);
                    }}
                    minDate={startDate}
                  />
                )}
              </div>
            </div>
          </div>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "30px" }}
          >
            <div style={{ flex: 1, marginRight: 30 }}>
              <div style={containerWrapper}>
                <div style={containerDiv}>
                  <text style={containerTitle}>Description</text>
                  <input
                    type="text"
                    value={schemeDescription}
                    onChange={(event) =>
                      setSchemeDescription(event.target.value)
                    }
                    style={descriptionInput}
                    placeholder="Description"
                  />
                </div>
              </div>
            </div>
            <div style={{ flex: 1 }} />
          </div>
        </div>
        <div style={{ marginTop: "50px" }}>
          <text style={infoText}>DISTRIBUTION</text>
          <div style={distributionTypeWrapper}>
            <DistributionSelect
              distributionType={distributionType}
              onClick={() => {
                setDistributionType("area");
                clearDistributions();
              }}
              label={"By Geography"}
              type={"area"}
            />
            <div style={{ marginLeft: 20 }}>
              <DistributionSelect
                distributionType={distributionType}
                onClick={() => {
                  setDistributionType("dealer");
                  clearDistributions();
                }}
                label={"By Dealer"}
                type={"dealer"}
              />
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <DistributionSelect
              distributionType={isSelectAll}
              onClick={() => {
                handleSelectAll();
              }}
              label={"Select All"}
              type={true}
            />
          </div>
          <div>
            {distributionType === "area" && (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 1, marginRight: 30 }}>
                  <ListSelect
                    heading="State"
                    defaultOption={
                      selectedState?.length ? selectedState[0]?.label : "State"
                    }
                    options={distributionType === "dealer" ? [] : states}
                    selectedOptions={selectedState}
                    showOptions={showStateList}
                    onClickShow={() =>
                      !isSelectAll && setShowStateList(!showStateList)
                    }
                    onClickOption={(val) => {
                      onChangeState(val);
                    }}
                    isSelectAll={allStateSelect}
                    onClickSelectAll={selectAllState}
                  />
                  <>
                    <div style={{ marginTop: "5px" }} />
                    {selectedState.length > 1 ? (
                      <SelectCross
                        title={"Clear All"}
                        onClick={() => {
                          setAllStateSelect(false);
                          setAllDistrictSelect(false);
                          setSelectedState([]);
                          setSelectedDistrict([]);
                          setShowAllStateList(false);
                        }}
                      />
                    ) : null}
                    {getSelectedStateList()?.map((val) => (
                      <SelectCross
                        title={val?.label ?? ""}
                        onClick={() => onChangeState(val)}
                      />
                    ))}
                    <div style={{ marginTop: "3px" }} />
                    {selectedState.length > 5 ? (
                      <SelectCross
                        title={showAllStateList ? "Hide All" : "Show All"}
                        onClick={() => {
                          if (showAllStateList) {
                            setShowAllStateList(false);
                          } else {
                            setShowAllStateList(true);
                          }
                        }}
                        icon={
                          showAllStateList ? "circleArrowUp" : "circleArrowDown"
                        }
                      />
                    ) : null}
                  </>
                </div>
                <div style={{ flex: 1 }}>
                  <ListSelect
                    heading="District"
                    defaultOption={
                      selectedDistrict?.length
                        ? selectedDistrict[0]?.label
                        : "District"
                    }
                    options={distributionType === "dealer" ? [] : districts}
                    selectedOptions={selectedDistrict}
                    showOptions={showDistrictList}
                    onClickShow={() => setShowDistrictList(!showDistrictList)}
                    onClickOption={(val) => {
                      onChangeDistrict(val);
                    }}
                    isSelectAll={allDistrictSelect}
                    onClickSelectAll={selectAllDistrict}
                  />
                  <>
                    <div style={{ marginTop: "5px" }} />
                    {selectedDistrict.length > 1 ? (
                      <SelectCross
                        title={"Clear All"}
                        onClick={() => {
                          setAllDistrictSelect(false);
                          setSelectedDistrict([]);
                          setShowAllDistrictList(false);
                          setSelectedTehsil([]);
                        }}
                      />
                    ) : null}
                    {getSelectedDistrictList()?.map((val) => (
                      <SelectCross
                        title={val?.label ?? ""}
                        onClick={() => onChangeDistrict(val)}
                      />
                    ))}
                    <div style={{ marginTop: "3px" }} />
                    {selectedDistrict.length > 5 ? (
                      <SelectCross
                        title={showAllDistrictList ? "Hide All" : "Show All"}
                        onClick={() => {
                          if (showAllDistrictList) {
                            setShowAllDistrictList(false);
                          } else {
                            setShowAllDistrictList(true);
                          }
                        }}
                        icon={
                          showAllDistrictList
                            ? "circleArrowUp"
                            : "circleArrowDown"
                        }
                      />
                    ) : null}
                  </>
                </div>
                <div style={{ flex: 1, marginLeft: 30, marginRight: 30 }}>
                  <ListSelect
                    heading="Tehsil"
                    options={distributionType === "dealer" ? [] : tehsils}
                    defaultOption={
                      selectedTehsil?.length && !isSelectAll
                        ? selectedTehsil[0]?.label
                        : "Tehsil"
                    }
                    selectedOptions={selectedTehsil}
                    showOptions={showTehsilList}
                    onClickShow={() => setShowTehsilList(!showTehsilList)}
                    onClickOption={(val) => {
                      onChangeTehsil(val);
                    }}
                    isSelectAll={allTehsilSelect}
                    onClickSelectAll={selectAllTehsil}
                  />
                  {!isSelectAll && (
                    <>
                      <div style={{ marginTop: "5px" }} />
                      {selectedTehsil.length > 1 ? (
                        <SelectCross
                          title={"Clear All"}
                          onClick={() => {
                            setAllTehsilSelect(false);
                            setSelectedTehsil([]);
                            setShowAllTehsilList(false);
                          }}
                        />
                      ) : null}
                      {getSelectedTehsilList()?.map((val) => (
                        <SelectCross
                          title={val?.label ?? ""}
                          onClick={() => onChangeTehsil(val)}
                        />
                      ))}
                      <div style={{ marginTop: "3px" }} />
                      {selectedTehsil.length > 5 ? (
                        <SelectCross
                          title={showAllTehsilList ? "Hide All" : "Show All"}
                          onClick={() => {
                            if (showAllTehsilList) {
                              setShowAllTehsilList(false);
                            } else {
                              setShowAllTehsilList(true);
                            }
                          }}
                          icon={
                            showAllTehsilList
                              ? "circleArrowUp"
                              : "circleArrowDown"
                          }
                        />
                      ) : null}
                    </>
                  )}
                </div>
                <div style={{ flex: 1, display: "flex" }}>
                  <div
                    style={{
                      marginTop: "90px",
                      marginLeft: "auto",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: isSubmitEnable()
                          ? "#003E85"
                          : "#F5F5F5",
                        border: "none",
                        padding: "11px",
                        paddingLeft: "17px",
                        paddingRight: "17px",
                        fontFamily: "Roboto-Bold",
                        color: isSubmitEnable() ? "#fff" : "#d1d1d1",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSubmit()}
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            )}
            {distributionType !== "area" && (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    marginRight: 30,
                  }}
                >
                  <div style={{ flex: 1, marginRight: 30 }}>
                    <ListSelect
                      heading="Dealer CBU"
                      defaultOption={
                        selectedDealerERP?.length
                          ? selectedDealerERP[0]?.label
                          : "Dealer CBU"
                      }
                      options={
                        distributionType === "dealer" ? dealersERPList : []
                      }
                      selectedOptions={selectedDealerERP}
                      showOptions={showERPList}
                      onClickShow={() =>
                        !isSelectAll && setShowERPList(!showERPList)
                      }
                      onClickOption={(val) => {
                        onChangeDealerERP(val);
                      }}
                      isSelectAll={allDealerERPSelect}
                      onClickSelectAll={selectAllDealerERP}
                    />
                    <>
                      <div style={{ marginTop: "5px" }} />
                      {selectedDealerERP.length > 1 ? (
                        <SelectCross
                          title={"Clear All"}
                          onClick={() => {
                            setAllDealerERPSelect(false);
                            setSelectedDealerERP([]);
                            setShowAllDealerERPList(false);
                          }}
                        />
                      ) : null}
                      {getSelectedDealerERPList()?.map((val) => (
                        <SelectCross
                          title={val?.label ?? ""}
                          onClick={() => onChangeDealer(val)}
                        />
                      ))}
                      <div style={{ marginTop: "3px" }} />
                      {selectedDealerERP.length > 5 ? (
                        <SelectCross
                          title={showAllDealerERPList ? "Hide All" : "Show All"}
                          onClick={() => {
                            if (showAllDealerERPList) {
                              setShowAllDealerERPList(false);
                            } else {
                              setShowAllDealerERPList(true);
                            }
                          }}
                          icon={
                            showAllDealerERPList
                              ? "circleArrowUp"
                              : "circleArrowDown"
                          }
                        />
                      ) : null}
                    </>
                  </div>
                  <div style={{ flex: 1 }}>
                    <ListSelect
                      heading="Dealership"
                      defaultOption={
                        selectedDealers?.length && !isSelectAll
                          ? selectedDealers[0]?.label
                          : "Dealership"
                      }
                      options={distributionType === "dealer" ? dealersList : []}
                      selectedOptions={selectedDealers}
                      showOptions={showDealerList}
                      onClickShow={() => setShowDealerList(!showDealerList)}
                      onClickOption={(val) => {
                        onChangeDealer(val);
                      }}
                      isSelectAll={allDealerSelect}
                      onClickSelectAll={selectAllDealer}
                    />
                    {!isSelectAll && (
                      <>
                        <div style={{ marginTop: "5px" }} />
                        {selectedDealers.length > 1 ? (
                          <SelectCross
                            title={"Clear All"}
                            onClick={() => {
                              setAllDealerSelect(false);
                              setSelectedDealers([]);
                              setShowAllDealerList(false);
                            }}
                          />
                        ) : null}
                        {getSelectedDealerList()?.map((val) => (
                          <SelectCross
                            title={val?.label ?? ""}
                            onClick={() => onChangeDealer(val)}
                          />
                        ))}
                        <div style={{ marginTop: "3px" }} />
                        {selectedDealers.length > 5 ? (
                          <SelectCross
                            title={showAllDealerList ? "Hide All" : "Show All"}
                            onClick={() => {
                              if (showAllDealerList) {
                                setShowAllDealerList(false);
                              } else {
                                setShowAllDealerList(true);
                              }
                            }}
                            icon={
                              showAllDealerList
                                ? "circleArrowUp"
                                : "circleArrowDown"
                            }
                          />
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
                <div style={{ flex: 1, display: "flex" }}>
                  <div
                    style={{
                      marginTop: "90px",
                      marginLeft: "auto",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: isSubmitEnable()
                          ? "#003E85"
                          : "#F5F5F5",
                        border: "none",
                        padding: "11px",
                        paddingLeft: "17px",
                        paddingRight: "17px",
                        fontFamily: "Roboto-Bold",
                        color: isSubmitEnable() ? "#fff" : "#d1d1d1",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSubmit()}
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {showSuccessModal && (
          <Modal
            onSubmit={() => {
              setShowSuccessModal(false);
              clearAddScheme();
              history.goBack();
            }}
            confirmTitle={"OK"}
          >
            <div style={{ display: "flex", alignSelf: "flex-end" }}>
              <Icon icon="circleClose" />
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                marginTop: "31px",
              }}
            >
              <Icon icon="checkIcon" />
            </div>
            <StyledText
              textAlign={"center"}
              width={"100%"}
              viewPadding={"20px 0px"}
            >
              Promotions & Offers has been updated successfully
            </StyledText>
          </Modal>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  app: { visible },
  schemes: { addSchemeSuccess, schemeById },
  dealers: { allStates, allDealers, allDistricts, allTehsils },
  user: { allModels },
}) => ({
  allStates,
  allDealers,
  addSchemeSuccess,
  visible,
  allModels,
  allTehsils,
  allDistricts,
  schemeById,
});

export default connect(mapStateToProps, {
  getAllSchemes: getAllSchemes,
  addScheme: addScheme,
  updateScheme: updateScheme,
  getAllDealers: getAllDealers,
  getAllStates: getAllStates,
  clearAddScheme: clearAddScheme,
  getAllModel: getAllModel,
  getAllDistricts: getAllDistricts,
  getAllTehsils: getAllTehsils,
  getSchemesById: getSchemesById,
})(UploadSchemes);
